<template>
    <div class="banner">
      <a-carousel :autoplay="true" :dotPosition="'left'">
        <div style="position: relative;">
            <a target="_blank" href="https://www.hchyn.cn"><img :src="require('../../assets/homebanner.png')" alt="" class="bannerImage"></a>
        </div>
        <div style="position: relative;">
            <img :src="require('../../assets/homebanner.jpg')" alt="" class="bannerImage">
            <div class="service">
                <span >{{$t('赛事一站式服务平台')}}</span>
            </div>
        </div>
      </a-carousel>
      <div class="bannerBottom">
        <div class="num-class">
          <p class="number ">
            {{ data.pkNum }}
            <!-- <NumberGrow :value="data.pkNum" :time='10'/> -->
            </p>
          <p>{{$t('比赛场次')}}</p>
        </div>
        <div class="num-class">
          <p class="number">
            {{ data.joinNum }}
            <!-- <NumberGrow :value="data.joinNum" :time='10'/> -->
          </p>
          <p>{{$t('参赛人次')}}</p>

        </div>
        <div class="num-class">
          <p class="number">
            {{ data.playerNum }}
            <!-- <NumberGrow :value="data.playerNum" :time='10'/> -->
          </p>
          <p>{{$t('运动员')}}</p>

        </div>
        <div class="num-class">
          <p class="number">
            {{ data.staffNum }}
            <!-- <NumberGrow :value="data.staffNum" :time='10'/> -->
          </p>
          <p>{{$t('教练')}}</p>

        </div>
        <div style="width: 180px;text-align: center;">
          <p class="number">
            {{ data.agencyNum }}
            <!-- <NumberGrow :value="data.agencyNum" :time='10'/> -->
          </p>
          <p>{{$t('机构')}}</p>
        </div>

      </div>
    </div>
</template>

<script>
import NumberGrow from '@comm/components/modal/NumberGrow.vue'
export default {
  name: 'Banner',
  components: {
    NumberGrow
  },
  mounted () {},
  data () {
    return {
      title: 'banner',
      data: {
        agencyNum: 0,
        pkNum: 0,
        matchNum: 0,
        playerNum: 0,
        joinNum: 0,
        staffNum: 0
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.$api.match.statisticalData().then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.num-class{
  width: 180px;
  text-align: center;
}
.club-class{
  background: rgb(201, 162, 95) none repeat scroll 0% 0%;
  padding: 20px 30px;
  border-radius: 10px;
  position: absolute;
  bottom: 100px;
  right: 520px;
  color: black;
  z-index: 9999;
}
.banner{
  height:580px;
  position: relative;
  top:-71px;
  .bannerImage{
    height: 580px;
    width:100%;
  }
  .service{
    width: 1200px;
    position: absolute;
    top: 320px;
    left:50%;
    transform: translateX(-600px);
    text-align: center;
    color: white;
    font-size: 48px;
    font-weight: bold;
  }
  .bannerBottom{
    position: absolute;
    display: flex;
    justify-content:space-around;
    align-items:center;
    bottom: 0px;
    width: 100%;
    padding: 10px 400px;
    background:rgba(199, 34, 34, 0.8);
    div{
      color: white;
      p{
        margin-bottom:0;
      }
      .number{
        font-size: 28px;
        font-weight: 600;
      }
    }
  }
}
.banner /deep/ .slick-slide {
  border: none;
}
.banner /deep/ .ant-carousel .slick-vertical .slick-slide{
  border: none;
  height: 580px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/HomeBanner.vue